import orderActionTypes from './action-types';

export const fetchGetUserAddress = payload => ({
  type: orderActionTypes.FETCH_GET_USER_ADDRESS,
  payload,
});

export const fetchGetUserAddressSuccess = payload => ({
  type: orderActionTypes.FETCH_GET_USER_ADDRESS_SUCCESS,
  payload,
});

export const fetchGetUserAddressFail = payload => ({
  type: orderActionTypes.FETCH_GET_USER_ADDRESS_FAIL,
  payload,
});

export const fetchAddUserAddress = payload => ({
  type: orderActionTypes.FETCH_ADD_USER_ADDRESS,
  payload,
});

export const fetchAddUserAddressSuccess = payload => ({
  type: orderActionTypes.FETCH_ADD_USER_ADDRESS_SUCCESS,
  payload,
});

export const fetchAddUserAddressFail = payload => ({
  type: orderActionTypes.FETCH_ADD_USER_ADDRESS_FAIL,
  payload,
});

export const fetchSearchProducts = payload => ({
  type: orderActionTypes.FETCH_SEARCH_PRODUCTS,
  payload,
});

export const fetchSearchProductsSuccess = payload => ({
  type: orderActionTypes.FETCH_SEARCH_PRODUCTS_SUCCESS,
  payload,
});

export const fetchSearchProductsFail = payload => ({
  type: orderActionTypes.FETCH_SEARCH_PRODUCTS_FAIL,
  payload,
});

export const resetSearchProducts = payload => ({
  type: orderActionTypes.RESET_SEARCH_PRODUCTS,
  payload,
});

export const fetchSubmitOrderBulk = payload => ({
  type: orderActionTypes.FETCH_SUBMIT_ORDER_BULK,
  payload,
});

export const fetchSubmitOrderBulkSuccess = payload => ({
  type: orderActionTypes.FETCH_SUBMIT_ORDER_BULK_SUCCESS,
  payload,
});

export const fetchSubmitOrderBulkFail = payload => ({
  type: orderActionTypes.FETCH_SUBMIT_ORDER_BULK_FAIL,
  payload,
});
